import { WorkPackageGeneratedEntity } from "./generated/WorkPackageGeneratedEntity";

export abstract class WorkPackageEntity extends WorkPackageGeneratedEntity {
    public get displayName(): string {
        return [this.index.trim(), this.name.trim()]
            .filter((x) => typeof x === "string" && x.trim().length > 0)
            .join(" - ");
    }
}
